import {Component, forwardRef, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {TerminalSearchPageComponent} from "../terminal-search-page/terminal-search-page.component";
import {TerminalSearchModel} from "../terminal-search.model";
import {TerminalEditPageComponent} from "../terminal-edit-page/terminal-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TerminalSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-terminal-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(TerminalSearchModel)
    ]
})
export class TerminalSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<TerminalSearchModel> implements OnInit {
    @Input() typeFilter: string;

    constructor(model: TerminalSearchModel, injector: Injector) {
        super(model, injector, "terminalId", "name", true);

        this.extendedSearchComponent = TerminalSearchPageComponent;
        this.extendedEditComponent = TerminalEditPageComponent;
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.model.filter["type"] = this.typeFilter;
    }

    override onOptionOpen(option: any) {
        this.selectControlComponent.openView(option);
    }
}
